import { gql } from "@apollo/client";

export default gql`
  mutation updateTeamMutation(
    $id: Int
    $organizationId: Int
    $addMemberIds: [Int!]
    $removeMemberIds: [Int!]
    $title: String
  ) {
    createOrUpdateTeam(
      teamId: $id
      organizationId: $organizationId
      addMemberIds: $addMemberIds
      removeMemberIds: $removeMemberIds
      title: $title
    ) {
      team {
        id
        title
        members {
          totalCount
          edges {
            node {
              id
              name
              avatar
            }
          }
        }
      }
    }
  }
`;
